import styled, { css, keyframes } from "styled-components";

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Container = styled.div`
  background: #fff;
  border-radius: var(--radius-md, 12px);
  border: 1px solid var(--border, rgba(26, 34, 82, 0.08));
  padding: 20px 24px;
  margin-bottom: 16px;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const Title = styled.h4`
  margin: 0 0 4px 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--navy, #1a2252);
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Subtitle = styled.p`
  margin: 0 0 16px 0;
  font-size: 13px;
  color: var(--gray-500, #6b7490);
`;

export const CpfRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const ResultBox = styled.div<{ $variant: "success" | "warning" | "error" | "info" }>`
  margin-top: 16px;
  padding: 14px 16px;
  border-radius: var(--radius-sm, 8px);
  display: flex;
  align-items: flex-start;
  gap: 12px;
  animation: ${fadeIn} 0.3s ease-out;

  ${({ $variant }) => {
    switch ($variant) {
      case "success":
        return css`
          background: #f0fdf4;
          border: 1px solid #86efac;
          color: #166534;
        `;
      case "warning":
        return css`
          background: #fffbeb;
          border: 1px solid #fcd34d;
          color: #92400e;
        `;
      case "error":
        return css`
          background: #fef2f2;
          border: 1px solid #fca5a5;
          color: #991b1b;
        `;
      case "info":
        return css`
          background: #eff6ff;
          border: 1px solid #93c5fd;
          color: #1e40af;
        `;
    }
  }}
`;

export const ResultContent = styled.div`
  flex: 1;
`;

export const ResultTitle = styled.p`
  margin: 0 0 4px 0;
  font-weight: 600;
  font-size: 14px;
`;

export const ResultDetail = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
`;

export const BadgeContainer = styled.span<{ $variant: "success" | "warning" | "error" | "neutral" }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: var(--radius-full, 9999px);
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;

  ${({ $variant }) => {
    switch ($variant) {
      case "success":
        return css`
          background: #dcfce7;
          color: #166534;
        `;
      case "warning":
        return css`
          background: #fef3c7;
          color: #92400e;
        `;
      case "error":
        return css`
          background: #fee2e2;
          color: #991b1b;
        `;
      case "neutral":
        return css`
          background: #f1f5f9;
          color: #475569;
        `;
    }
  }}
`;
